/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderPaginationResponseAllOfDataInner } from './OrderPaginationResponseAllOfDataInner';
import {
    OrderPaginationResponseAllOfDataInnerFromJSON,
    OrderPaginationResponseAllOfDataInnerFromJSONTyped,
    OrderPaginationResponseAllOfDataInnerToJSON,
    OrderPaginationResponseAllOfDataInnerToJSONTyped,
} from './OrderPaginationResponseAllOfDataInner';

/**
 * 
 * @export
 * @interface OrderPaginationResponse
 */
export interface OrderPaginationResponse {
    /**
     * 全体件数
     * @type {number}
     * @memberof OrderPaginationResponse
     */
    totalCount?: number;
    /**
     * 現在のページ番号
     * @type {number}
     * @memberof OrderPaginationResponse
     */
    page?: number;
    /**
     * 1ページあたりの件数
     * @type {number}
     * @memberof OrderPaginationResponse
     */
    count?: number;
    /**
     * 総ページ数
     * @type {number}
     * @memberof OrderPaginationResponse
     */
    totalPages?: number;
    /**
     * 
     * @type {Array<OrderPaginationResponseAllOfDataInner>}
     * @memberof OrderPaginationResponse
     */
    data?: Array<OrderPaginationResponseAllOfDataInner>;
}

/**
 * Check if a given object implements the OrderPaginationResponse interface.
 */
export function instanceOfOrderPaginationResponse(value: object): value is OrderPaginationResponse {
    return true;
}

export function OrderPaginationResponseFromJSON(json: any): OrderPaginationResponse {
    return OrderPaginationResponseFromJSONTyped(json, false);
}

export function OrderPaginationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPaginationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'page': json['page'] == null ? undefined : json['page'],
        'count': json['count'] == null ? undefined : json['count'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(OrderPaginationResponseAllOfDataInnerFromJSON)),
    };
}

export function OrderPaginationResponseToJSON(json: any): OrderPaginationResponse {
    return OrderPaginationResponseToJSONTyped(json, false);
}

export function OrderPaginationResponseToJSONTyped(value?: OrderPaginationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'page': value['page'],
        'count': value['count'],
        'totalPages': value['totalPages'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(OrderPaginationResponseAllOfDataInnerToJSON)),
    };
}

